export default __webpack_public_path__ + "static/media/Mark-3-Suit-Cycles-12.61e72420.jpg";